<template>
  <g>
    <rect
      id="svg_1"
      fill="#3769d6"
      x="22.66666"
      y="34.33334"
      width="24"
      height="4"
      stroke-width="0"
      rx="3"
    />
    <rect
      id="svg_2"
      fill="#3769d6"
      x="-59.43724"
      y="-31.99984"
      width="45.99984"
      height="30.74989"
    />
    <rect
      id="svg_3"
      fill="#3769d6"
      x="32.8333"
      y="23.33332"
      width="4"
      height="24.1875"
      stroke-width="0"
      rx="3"
    />
  </g>
</template>
